import { FC } from "react"
import { ProveedoresTableHerbaceo } from "./ProveedoresTableHerbaceo/ProveedoresTableHerbaceo"
import { PropioTableHerbaceo } from "./PropioTableHerbaceo/PropioTableHerbaceo"

export const ProveedoresHerbaceo:FC<any> = (props):JSX.Element => {

    const {proveedores,data,dataMASTER,setData,setDataMASTER,changesFlag, setChangesFlag,fullData}  = props
    return (
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'92.5%',width:'100%'}}>
            {
                !proveedores?
                    <ProveedoresTableHerbaceo
                        data={data?.herbaceo_proveedores_table}
                        setData={setData}
                        dataMASTER={dataMASTER?.herbaceo_proveedores_table}
                        fullData={fullData}
                        setDataMASTER={setDataMASTER}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                    />
                    :
                    <PropioTableHerbaceo
                        data={data?.herbaceo_propio_table}
                        setData={setData}
                        dataMASTER={dataMASTER?.herbaceo_propio_table}
                        fullData={fullData}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                    />
            }
        </div>
    )
}